// extracted by mini-css-extract-plugin
module.exports = {"containerIcon":"_3Y4icwWO3ftbzAfxHDzNvq","checkoutV2":"_3R1Y20m1_f3hLlZvYcMnEr","menu":"SOO2sKjVoouQXfb9EUBlO","title":"_2JZWl1U29v6Dh5D4cF295Z"};